import pick from 'lodash/pick'
import omit from 'lodash/omit'
import { isEmptyString } from 'lib/detectType'

export const objectToTagString = ({ tagName, props, children }) => {
  const nonameProp = pick(props, ['_'])
  const tagProps = omit(props, ['_'])
  const tagPropsCount = Object.keys(tagProps).length
  const nonamePropString = !isEmptyString(nonameProp?._)
    ? `="${nonameProp?._}"`
    : ``
  const tagPropsString = Object.entries(tagProps)
    .map(([key, value]) => {
      return `${key}="${value}"`
    })
    .join(' ')
  const tagString = `<${tagName}${nonamePropString}${
    tagPropsCount > 0 ? ` ${tagPropsString}` : ``
  }>${children}</${tagName}>`
  return tagString
}

export const tagStringToObject = tagString => {
  const tagName = tagString.match(/<(\w+)(.*?)>/)[1]
  const propsString = tagString.match(/<\w+(.*?)>/)[1]
  const props = Object.assign(
    {},
    ...propsString
      .split(' ')
      .filter(prop => {
        return !isEmptyString(prop)
      })
      .map(prop => {
        const [key, value] = prop.split('=')
        return { [isEmptyString(key) ? '_' : key]: value.replace(/"/g, '') }
      })
  )
  const children = tagString.match(/>(.*?)</)[1]
  return {
    tagName,
    props,
    children
  }
}
